import InfoDialog from './InfoDialog'

export default InfoDialog
